/**
 * @generated SignedSource<<b7fe471ab71ec7932c75a1188beb86e7>>
 * @relayHash eca9636b1d8c8e236b413254a8d35c12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90da163b5bb4915cd69a5ae83f6d390b7677f54cec00afeb87dd58ca0c0824be

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HelpCenterManagementAppQuery } from './HelpCenterManagementAppQuery.graphql';

const node: PreloadableConcreteRequest<HelpCenterManagementAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "90da163b5bb4915cd69a5ae83f6d390b7677f54cec00afeb87dd58ca0c0824be",
    "metadata": {},
    "name": "HelpCenterManagementAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
